import { createStore, StateMachineProvider } from 'little-state-machine'
import App from './components/App'
import { FromSitecorePropsType } from './interfaces'

createStore(
  {
    address: '',
    active: true,
    completed: true,
    registered: true,
    major: true,
    ready: false,
    markerData: [],
    features: [],
    markers: [],
    getAddress: void 0,
    reportFormUrl: void 0,
    outagesFormUrl: void 0
  } as Record<string, any>,
  { name: 'outages' }
)

const OutageMap = (props: FromSitecorePropsType) => {
  return (
    <StateMachineProvider>
      <App {...props} />
    </StateMachineProvider>
  )
}

export default OutageMap
